import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'
import { Observable } from 'rxjs/Observable'

import 'rxjs/add/observable/fromPromise'

import { Configuracao } from '../../pkw-data/core/configuracao/configuracao.model'
import { TipoDeConfiguracaoId } from '../../pkw-data/core/configuracao/tipo-de-configuracao-id.enum'
import { ConfiguracaoService } from './configuracao.service'

@Injectable()
export class ConfiguracaoIntegracaoCollectPorBandeiraResolver
    implements Resolve<Configuracao> {
    constructor(private configuracaoService: ConfiguracaoService) {}

    resolve() {
        return this.configuracaoService
            .obter(TipoDeConfiguracaoId.IntegracaoCollectPorBandeira)
            .concatMap(configuracao => {
                if (configuracao) {
                    return Observable.of(configuracao)
                }

                return Observable.fromPromise(
                    this.configuracaoService.nova(
                        TipoDeConfiguracaoId.IntegracaoCollectPorBandeira
                    )
                )
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/configuracao/shared/configuracao-integracao-collect-por-bandeira.resolver.ts